import { useCallback, useState } from "react";
import { type Location, useBlocker } from "react-router-dom";

interface UseNavigationBlockProps {
  when: boolean;
  message?: string;
}

export const useNavigationBlock = ({ when }: UseNavigationBlockProps) => {
  const [pendingNavigation, setPendingNavigation] = useState<(() => void) | null>(null);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const confirmNavigation = useCallback(() => {
    if (pendingNavigation) {
      pendingNavigation();
      setPendingNavigation(null);
    }
    setIsConfirmModalOpen(false);
  }, [pendingNavigation]);

  const cancelNavigation = useCallback(() => {
    setPendingNavigation(null);
    setIsConfirmModalOpen(false);
  }, []);

  useBlocker(
    useCallback(
      ({ currentLocation, nextLocation }: { currentLocation: Location; nextLocation: Location }) => {
        if (when && currentLocation.pathname !== nextLocation.pathname) {
          setPendingNavigation(() => () => {
            // Navigation will be handled by the confirm action
            window.location.href = nextLocation.pathname + nextLocation.search + nextLocation.hash;
          });
          setIsConfirmModalOpen(true);
          return true; // Block the navigation
        }
        return false;
      },
      [when],
    ),
  );

  return {
    isConfirmModalOpen,
    confirmNavigation,
    cancelNavigation,
  };
};
